import { Injectable } from "@angular/core";
import type { ItemsService } from "@app/@classes/abstract/items-service-interface";
import { ItemsTableServiceBase } from "@app/@classes/abstract/items-table-service";
import type { Tables } from "@app/@classes/supabase";

const TABLE = "tenant_users";
type T = typeof TABLE;

@Injectable({
  providedIn: "root",
})
export class TenantUsersService
  extends ItemsTableServiceBase<Tables<T>>
  implements ItemsService<Tables<T>> {
  constructor() {
    super(TABLE, { hasTenant: false });
  }

  override defaultItem(): Tables<T> {
    return {
      created_at: null,
      created_by: null,
      id: this.randomUUID(),
      role: "member",
      tenant_id: "",
      updated_at: null,
      updated_by: null,
      user_id: "",
      invitation_email: null,
      invitation_status: "pending",
      invitation_token: this.randomUUID(),
      invited_by_user_id: null,
    };
  }
}
